import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import { msalInstance, handleAuthenticationEvents } from "./Auth/AuthConfig";
handleAuthenticationEvents();
ReactDOM.render(_jsx(App, { loginInstance: msalInstance }), document.getElementById("root"));
